import { render, staticRenderFns } from "./CreateCompanyEvent.vue?vue&type=template&id=25edea59&scoped=true&"
import script from "./CreateCompanyEvent.vue?vue&type=script&lang=js&"
export * from "./CreateCompanyEvent.vue?vue&type=script&lang=js&"
import style0 from "./CreateCompanyEvent.vue?vue&type=style&index=0&id=25edea59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25edea59",
  null
  
)

export default component.exports